import { useMediaQuery } from 'react-responsive';
import DiscoveryAiDesktopCard from './DiscoveryAiDesktopCard';
import { useDesktopAiInputRef, useMobileAiAssistantState } from '../../MobileAiAssistantContext';
import { AI_SOURCE_OPTIONS } from '../../MobileAiAssistant';

// Inline desktop Ask Abroadify card for map-first Discovery pages, mounted
// right after the tabs row. Driven by the shared assistant state; renders
// nothing on mobile or on pages that did not register as mapFirst.
// (/discovery/companies/jobs renders DiscoveryAiDesktopCard itself and does
// not use this slot, so it never gets two cards.)
const DiscoveryDesktopAiSlot = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 767.98px)' });
    const inputRef = useDesktopAiInputRef();
    const assistant = useMobileAiAssistantState();

    if (isMobile || !assistant?.pageContext?.mapFirst) return null;

    return (
        <div className="row mb-4">
            <div className="col">
                <DiscoveryAiDesktopCard
                    inputRef={inputRef}
                    aiQuery={assistant.aiQuery}
                    setAiQuery={assistant.setAiQuery}
                    aiLoading={assistant.aiLoading}
                    aiResult={assistant.aiResult}
                    aiError={assistant.aiError}
                    sourceOptions={AI_SOURCE_OPTIONS}
                    selectedAiSources={assistant.selectedAiSources}
                    toggleAiSource={assistant.toggleAiSource}
                    onSubmit={assistant.submitAiQuery}
                />
            </div>
        </div>
    );
};

export default DiscoveryDesktopAiSlot;
